import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
// Import the logo file
import logo from '../assets/FCH_Logo_v2-removebg-preview.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { B } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: B.bg,
      fontFamily: "'Poppins', sans-serif",
      padding: '16px'
    }}>
      {/* Logo only - Replaced text with logo */}
      <div style={{
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'center'
      }}>
        <img
          src={logo}
          alt="Forward Care Hub Logo"
          style={{
            height: 60, // Adjust height as needed
            width: 'auto', // Maintain aspect ratio
            objectFit: 'contain'
          }}
        />
      </div>

      {/* Login Card */}
      <div style={{
        background: B.white,
        borderRadius: 20,
        padding: 'clamp(24px, 8vw, 40px) clamp(20px, 6vw, 36px)',
        width: '100%',
        maxWidth: 400,
        boxShadow: '0 8px 40px rgba(25,73,132,0.12)',
        border: `1px solid ${B.border}`
      }}>
        <div style={{
          fontSize: 'clamp(18px, 5vw, 22px)',
          fontWeight: 800,
          color: B.navy,
          marginBottom: 6,
          textAlign: 'center'
        }}>
          Welcome back
        </div>
        <div style={{
          fontSize: 12,
          color: B.muted,
          textAlign: 'center',
          marginBottom: 28
        }}>
          Sign in to your account
        </div>

        {error && (
          <div style={{
            background: '#fee2e2',
            color: '#dc2626',
            padding: '10px 14px',
            borderRadius: 8,
            fontSize: 12,
            marginBottom: 16,
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{
              fontSize: 11,
              fontWeight: 600,
              color: B.text,
              display: 'block',
              marginBottom: 4
            }}>
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email"
              required
              style={{
                width: '100%',
                fontSize: 14,
                padding: '12px 14px',
                borderRadius: 10,
                border: `1.5px solid ${B.border}`,
                fontFamily: 'inherit',
                color: B.text,
                background: B.white,
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{
              fontSize: 11,
              fontWeight: 600,
              color: B.text,
              display: 'block',
              marginBottom: 4
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password"
              required
              style={{
                width: '100%',
                fontSize: 14,
                padding: '12px 14px',
                borderRadius: 10,
                border: `1.5px solid ${B.border}`,
                fontFamily: 'inherit',
                color: B.text,
                background: B.white,
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: 10,
              border: 'none',
              background: B.navy,
              color: '#fff',
              fontSize: 14,
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit',
              marginBottom: 16,
              boxShadow: '0 4px 14px rgba(25,73,132,0.3)',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}